import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import ReportGuideExportButton from './ReportGuideExportButton';
import React from 'react';
import ReportGuideTotal from './ReportGuideTotal';
import { useFetchReportGuides } from './hooks/useFetchReportGuides';
import ReportGuideFilterBox from './ReportGuideFilterBox';
import { ReportGuideProvider } from './hooks/useReportGuide';
import Pagination from 'components/pagination/Pagination';
import { useDisplayMode } from 'hooks/useDisplayMode';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';
import PaginationProvider from 'hooks/pagination';
import ReportGuideListTable from './list/table/ReportGuideListTable';
import ReportGuideListModule from './list/module/ReportGuideListModule';
import { styled } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
  boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
  '& > p': {
    padding: theme.spacing(3),
  },
}));

const ReportGuide: React.FC = () => {
  const {
    filter,
    handleChange,
    loading,
    handleSearch,
    handleSort,
    exportExcel,
    exporting,
    order,
    guides,
    summary,
    anchorEl,
    setAnchorEl,
    selectedGuide,
    setSelectedGuide,
    setPage,
    setRows,
    rows,
    page,
    total,
  } = useFetchReportGuides();
  const [displayMode] = useDisplayMode();
  return (
    <ReportGuideProvider
      value={{
        filter,
        handleChange,
        handleSearch,
        guides,
        summary,
        loading,
        anchorEl,
        setAnchorEl,
        setSelectedGuide,
        selectedGuide,
      }}
    >
      <Appbar
        title="Relatórios - Consulta"
        ActionsComponent={<ReportGuideExportButton compact onClick={exportExcel} loading={exporting} />}
      />
      <PageHeaderActions
        title="Consultas Médicas"
        description="Analise de atendimentos, faturamento e descontos"
        backUrl="/reports"
        ActionComponent={<ReportGuideExportButton onClick={exportExcel} loading={exporting} />}
      />

      <ReportGuideTotal />

      <ReportGuideFilterBox filter={filter} handleChange={handleChange} handleSearch={handleSearch} loading={loading} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : guides.length === 0 ? (
          <NoData message="Relatório indisponível" />
        ) : (
          <Container>
            {displayMode === 'list' ? (
              <ReportGuideListTable handleSort={handleSort} order={order} guides={guides} />
            ) : (
              <ReportGuideListModule guides={guides} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </Container>
        )}
      </PaginationProvider>
    </ReportGuideProvider>
  );
};

export default ReportGuide;
